import type { AvailableCountries, Country } from '~/types/country';

export function useCountrySwitch() {
    const config = useRuntimeConfig();

    const country = useState('country');

    const countryConfig: Record<AvailableCountries, Country> = {
        com: {
            translation: 'global.country.com.title',
            defaultLocale: 'en-GB',
            prefix: '/com',
            accessToken: config.public.country.com.accessToken ?? '',
            value: 'com',
        },
        de: {
            translation: 'global.country.de.title',
            defaultLocale: 'de-DE',
            prefix: '',
            accessToken: config.public.country.de.accessToken ?? '',
            value: 'de',
        },
        fr: {
            translation: 'global.country.fr.title',
            defaultLocale: 'fr-FR',
            prefix: '/fr',
            accessToken: config.public.country.fr.accessToken ?? '',
            value: 'fr',
        },
    };

    const url = (link: string | RouteObject) => {
        let url = link;
        if (link?.path) {
            url = link.path;
        }

        if (countryConfig[country.value]?.prefix) {
            return `${countryConfig[country.value]?.prefix}${url}`;
        }

        return url;
    };

    const sanitizeRoutePath = (path: string) => {
        const { locale } = useI18n();
        return path.replace(`${locale.value}`, '').replace('//', '/').replace('/com/', '/').replace('/fr/', '/');
    };

    const deleteCart = async (swContextToken: string) => {
        await $fetch(`${config.public.pond.shopwareEndpoint}/store-api/context/delete-cart`, {
            method: 'POST',
            headers: {
                'sw-access-key': countryConfig[country.value]?.accessToken,
                'sw-context-token': swContextToken,
            },
        });
    };

    return {
        countryConfig,
        url,
        sanitizeRoutePath,
        deleteCart,
    };
}
